import React from 'react';

import { twMerge } from 'tailwind-merge';
import Button from 'flow/components/ui-components/Button';

type Props = {
    handleClick?: () => void;
    message: React.ReactNode;
    buttonText?: string;
    theme?: 'warning' | 'default';
};

const backgroundThemes = {
    warning: 'bg-yellow text-gray-800 dark:text-gray-100',
    default: 'bg-gray-800 text-white',
};

const buttonThemes = {
    warning: 'bg-yellow text-gray-800 dark:text-gray-100',
    default: 'bg-gray-600 text-white',
};

const NotifierBanner = ({
    handleClick,
    message,
    buttonText,
    theme = 'default',
}: Props) => {
    return (
        <div className={twMerge('px-3', backgroundThemes[theme])}>
            <div className="flex items-center justify-between gap-2 py-2 text-sm font-medium">
                {message}
                {buttonText && handleClick && (
                    <Button
                        className={twMerge(
                            'hover:darken-20 whitespace-nowrap',
                            buttonThemes[theme],
                        )}
                        onClick={handleClick}
                    >
                        {buttonText}
                    </Button>
                )}
            </div>
        </div>
    );
};
export default NotifierBanner;
